/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectState
 */
export interface ProjectState {
    /**
     * 
     * @type {string}
     * @memberof ProjectState
     */
    status: ProjectStateStatusEnum;
    /**
     * Should the project be public?
     * @type {boolean}
     * @memberof ProjectState
     */
    statusIsVisibleOnWeb: boolean;
    /**
     * Arbitrary result status; can be manually changed by administrator
     * @type {string}
     * @memberof ProjectState
     */
    result: ProjectStateResultEnum | null;
    /**
     * Whether the project is *actually* successful, i.e. doesnt just have `success` result, but does indeed perform well, according to localized criteria
     * @type {boolean}
     * @memberof ProjectState
     */
    actualSuccess: boolean;
}


/**
 * @export
 */
export const ProjectStateStatusEnum = {
    UserDraft: 'user-draft',
    UserDraftSubmitted: 'user-draft-submitted',
    UserDraftReturned: 'user-draft-returned',
    UserDraftRejected: 'user-draft-rejected',
    Draft: 'draft',
    Cancelled: 'cancelled',
    Scheduled: 'scheduled',
    Active: 'active',
    Finished: 'finished',
    Closed: 'closed'
} as const;
export type ProjectStateStatusEnum = typeof ProjectStateStatusEnum[keyof typeof ProjectStateStatusEnum];

/**
 * @export
 */
export const ProjectStateResultEnum = {
    Success: 'success',
    Failure: 'failure'
} as const;
export type ProjectStateResultEnum = typeof ProjectStateResultEnum[keyof typeof ProjectStateResultEnum];


/**
 * Check if a given object implements the ProjectState interface.
 */
export function instanceOfProjectState(value: object): value is ProjectState {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusIsVisibleOnWeb' in value) || value['statusIsVisibleOnWeb'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('actualSuccess' in value) || value['actualSuccess'] === undefined) return false;
    return true;
}

export function ProjectStateFromJSON(json: any): ProjectState {
    return ProjectStateFromJSONTyped(json, false);
}

export function ProjectStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectState {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusIsVisibleOnWeb': json['statusIsVisibleOnWeb'],
        'result': json['result'],
        'actualSuccess': json['actualSuccess'],
    };
}

export function ProjectStateToJSON(json: any): ProjectState {
    return ProjectStateToJSONTyped(json, false);
}

export function ProjectStateToJSONTyped(value?: ProjectState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'statusIsVisibleOnWeb': value['statusIsVisibleOnWeb'],
        'result': value['result'],
        'actualSuccess': value['actualSuccess'],
    };
}

